import { useCallback, useEffect, useMemo, useState } from "react";
import { loadPreferences, PREFERENCES_KEY, savePreferences } from "../platform/preferences";
import { createLocalStorage } from "../platform/storage";
import type { Preferences } from "../types/preferences";

const storage = createLocalStorage(PREFERENCES_KEY);

function reflectToRoot(prefs: Preferences) {
  if (typeof document === "undefined") return;
  const root = document.documentElement;
  root.setAttribute("data-theme", prefs.theme);
  root.setAttribute("data-juice", prefs.juice);
  if (prefs.reducedMotion === null) {
    root.removeAttribute("data-reduced-motion");
  } else {
    root.setAttribute("data-reduced-motion", String(prefs.reducedMotion));
  }
}

export function usePreferences() {
  const [prefs, setPrefs] = useState<Preferences>(() => loadPreferences(storage));

  useEffect(() => {
    reflectToRoot(prefs);
    savePreferences(storage, prefs);
  }, [prefs]);

  const update = useCallback((patch: Partial<Preferences>) => {
    setPrefs((current) => ({ ...current, ...patch }));
  }, []);

  return useMemo(() => ({ prefs, update }), [prefs, update]);
}
